
<template>
  <form id="formStepLegal" data-vv-scope="step-legal">
    <div class="vx-row">
      <div class="vx-col">آیا شما یک شخص حقوقی می باشید؟</div>
      <div class="vx-col">
        <vs-switch v-model="isLegal" style="width: 6em" name="isLegal">
          <span slot="on">حقوقی</span>
          <span slot="off">حقیقی</span>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row" v-if="isLegal">
      <div class="vx-col md:w-6/12 w-full">
        <vs-input
          label="نام شرکت*"
          name="coName"
          v-model="draftRequest.draftMerchant.comNameFa"
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-6/12 w-full">
        <vs-input
          name="coNameEn"
          label="Company Name"
          v-model="draftRequest.draftMerchant.comNameEn"
          class="w-full mt-4"
          style="direction: ltr"
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          label="شناسه ملی اشخاص حقوقی*"
          v-validate="'numeric'"
          name="nationalLegalCode"
          v-model="draftRequest.draftMerchant.nationalLegalCode"
          class="w-full ltr-input mt-4"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-legal.nationalLegalCode")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <vs-input
          label="کد اقتصادی"
          v-validate="'numeric'"
          name="commercialCode"
          v-model="draftRequest.draftMerchant.commercialCode"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-legal.commercialCode")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <vs-input
          label="شماره ثبت شرکت"
          v-validate="'numeric'"
          name="registerNumber"
          v-model="draftRequest.draftMerchant.registerNumber"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-legal.registerNumber")
        }}</span>
      </div>
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">تاریخ ثبت شرکت*</div>
        <date-picker
          name="registerDate"
          inputClass="py-1 px-5  w-full"
          v-model="registerDate"
        ></date-picker>
      </div>
    </div>
    <div class="vx-col w-full">
      <vs-button
        @click="saveLegalData"
        class="my-3"
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-save"
        >ذخیره اطلاعات حقوقی</vs-button
      >
    </div>
  </form>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
</style>
<script>
const dict = {
  custom: {
    nationalLegalCode: {
      numeric: "فقط عدد وارد کنید",
    },
    commercialCode: {
      numeric: "فقط عدد وارد کنید",
    },
    registerNumber: {
      numeric: "فقط عدد وارد کنید",
    },
    businessCertificateNumber: {
      numeric: "فقط عدد وارد کنید",
    },
  },
};
import Vue from "vue";
Validator.localize("en", dict);

import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { BirthCrtfctSeriesLetter, CreateEditMode } from "@/enums.js";
export default {
  name: "edit-legal-data",
  props: {},
  components: {
    "v-select": vSelect,
  },
  props: {
    draftRequest: {
      default: () => {
        return {
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
      },
    },
  },
  data() {
    return {
      registerDate: "",
      isLegal: false,
    };
  },
  watch: {
    draftRequest: {
      handler: function () {
        this.isLegal = !!this.draftRequest.draftMerchant.merchantType;
        if (this.draftRequest.draftMerchant.registerDate != null)
          this.registerDate = this.$moment(
            this.draftRequest.draftMerchant.registerDate,
            "YYYY/MM/DD"
          ).format("jYYYY/jM/jD");
      },
    },
  },
  methods: {
    saveLegalData() {
      if (!this.validateLegalData) return;
      let loading = this.$vs.loading();
      let payload = {
        id: this.draftRequest.id,
        merchantType: this.isLegal&&1||0,
        registerNumber: this.draftRequest.draftMerchant.registerNumber,
        coName: this.draftRequest.draftMerchant.comNameFa,
        coNameEn: this.draftRequest.draftMerchant.comNameEn,
        nationalLegalCode: this.draftRequest.draftMerchant.nationalLegalCode,
        commercialCode: this.draftRequest.draftMerchant.commercialCode,
      };
      if (this.registerDate) {
        payload.registerDate = this.$moment(
          this.registerDate,
          "jYYYY/jMM/jDD"
        ).format();
      }

      this.$http
        .post("/api/services/app/Draft/EditLegalData", payload)
        .then((response) => {
          if (response.data.result == true) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "اطلاعات حقوقی با موفقیت ذخیره شد",
            });
            this.$vs.loading.close();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    validateLegalData() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-legal").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
  },
  mounted() {},
};
</script>